import { useClickOutside } from './useClickOutside.ts';

export { withClickOutside } from './withClickOutside.tsx';

export { useClickOutside };
export default useClickOutside;
